import { Textfield, OptionEditor, Number, Dropdown } from '../formFields'

const TOAST_VARIANTS = [
  { label: 'Success', value: 'success' },
  { label: 'Error', value: 'error' },
  { label: '---', value: '' },
]

const VERTICAL_ALIGNMENT_OPTIONS = [
  { label: 'Top', value: 'top' },
  { label: 'Middle', value: 'middle' },
  { label: 'Bottom', value: 'bottom' },
]

export const HEADING_LEVELS = [
  { label: 'H1', value: 1 },
  { label: 'H2', value: 2 },
  { label: 'H3', value: 3 },
  { label: 'H4', value: 4 },
  { label: 'H5', value: 5 },
  { label: 'H6', value: 6 },
]

export const BUTTON_VARIANTS = [
  { label: 'CTA', value: 'cta' },
  { label: 'Link', value: 'link' },
  { label: 'Primary', value: 'primary' },
  { label: 'Secondary', value: 'secondary' },
  { label: 'Negative', value: 'negative' },
]

export const ALIGNMENT_OPTIONS = [
  { label: 'Left', value: 'left' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'right' },
]

export const TOOLTIPS = {
  LABEL: 'Field label displayed right above it. Often used as a fall-back value for placeholder.',
  LINK: 'Screen to navigate to on click. Redirect is performed after triggering events and sending webhook requests.',
  EVENT_TYPE: 'Type (name) of browser JavaScript event to send. Used to trigger Data Collection Rules.',
  WEBHOOK:
    'URL to send a request to on click. Request will contain all data gathered on site or only in fields with matching Form Id.',
  DATA: 'Valid JavaScript object with properties to add to dataLayer and webhooks on click. Can be used to set properties that don\' have visual components on the site, eg. {"enrollment.selectedPlan": "ppo"}',
  FORM_ID:
    'If Webhook URL is provided, setting Form Id will modify request payload to only include fields with matching Form Id. Otherwise everything is sent. ',
  NAME: 'Name of the property under which field value will be stored in request or dataLayer. Overriden by path. Either name or path must be set to store field in dataLayer or request payload.',
  PATH: 'Path under which field value will be stored in request or dataLayer. Must match AEP schema to enable pre-filling from profile. Eg. person.name.firstName. If empty, name is used. . Either name or path must be set to store field in dataLayer or request payload.',
  PRE_FILL:
    "If empty, try to populate this field with data inserted in current browser tab or from AEP Profile. name or path must match other component's or AEP schema.",
  DEFAULT_VALUE:
    'Fixed value used for pre-filling the empty field if no matching data is found in local and AEP Profile',
}

export const eventType = Textfield({
  name: 'eventType',
  label: 'Event Type',
  tooltip: TOOLTIPS.EVENT_TYPE,
})
export const webhookUrl = Textfield({
  name: 'webhookUrl',
  label: 'Webhook URL',
  tooltip: TOOLTIPS.WEBHOOK,
})
export const data = OptionEditor({
  name: 'data',
  label: 'Custom Data',
  columns: [
    { name: 'label', label: 'Property Name/Path', isKey: true },
    { name: 'valueType', label: 'Type', type: 'fieldType' },
    { name: 'value', label: 'Value', type: 'dynamic', typeColumn: 'valueType' },
  ],
  saveAs: 'array',
  tooltip: TOOLTIPS.DATA,
})
export const delay = Number({
  name: 'delay',
  label: 'Delay (miliseconds)',
  min: 0,
  max: 10000,
  tooltip: 'Number of milliseconds to wait until executing an action',
})
export const toastVariant = Dropdown({
  name: 'toastVariant',
  label: 'Toast Variant',
  options: TOAST_VARIANTS,
  filter: null,
})
export const toastMessage = Textfield({
  name: 'toastMessage',
  label: 'Toast Message',
})
export const alignment = Dropdown({
  name: 'alignment',
  label: 'Alignment',
  options: ALIGNMENT_OPTIONS,
  filter: null,
})
export const verticalAlignment = Dropdown({
  name: 'verticalAlignment',
  label: 'Vertical Alignment',
  options: VERTICAL_ALIGNMENT_OPTIONS,
  filter: null,
})
export const direction = Dropdown({
  name: 'direction',
  label: 'Direction',
  options: [
    { label: 'Vertical', value: 'vertical' },
    { label: 'Horizontal', value: 'horizontal' },
  ],
  filter: null,
})
